<div
    class="sera__info__text"
    ngClass="sera__info__text--{{ typeOfText }}">
    <i
        class="ci"
        [ngClass]="icon">
    </i>
    <span class="sera__info__text__text">{{ text | translate }}</span>
</div>
